// extracted by mini-css-extract-plugin
export var localeSelector = "_46-0";